import isProduction from "./isProduction";

var devFreeze = function devFreeze(obj) {
  return isProduction() ? obj : Object.freeze(obj);
};

export default devFreeze;